import React from "react";
import { Routes } from "react-router-dom";
import { mainRoutes } from "./main";
import { galleryRoutes } from "./gallery";
import { eventRoutes } from "./events";
import { vibesRoutes } from "./vibes";
import { authRoutes } from "./auth";

export const AppRoutes = () => {
  return (
    <Routes>
      {authRoutes}
      {mainRoutes}
      {galleryRoutes}
      {eventRoutes}
      {vibesRoutes}
    </Routes>
  );
};
